import { useBankContext, useBrandContext } from '../dictionaries/context/BankContext';
import { useCountryContext } from '../dictionaries/context/CountryContext';
import {
  BankType,
  BrandType,
  Country,
  GlobalSettingByEntity,
  SettingNameType,
  useGetSettingQuery,
} from '../generated/graphql';
import { DomainKey, getGlobalSettingDomainByEntity } from './getGlobalSettingDomainByEntity';

export function useGetGlobalSettingDomainByEntity<K extends DomainKey>(
  domainKey: K,
): GlobalSettingByEntity[K] | null {
  const { data, loading } = useGetSettingQuery({
    variables: {
      name: SettingNameType.GlobalSettingByEntity,
    },
    fetchPolicy: 'cache-first',
  });
  const [ brand = BrandType.Tranquiapp ] = useBrandContext();
  const [ bank = BankType.NoBank ] = useBankContext();
  const [ country = Country.Co ] = useCountryContext();
  if (loading) return null;
  const settingsList = data?.setting?.globalSettingByEntity;
  if (!settingsList) return null;
  return getGlobalSettingDomainByEntity({
    settingsList,
    input: {
      brand,
      bank: bank as BankType,
      country,
    },
    domainKey,
  });
}
